// Import-free on purpose, and imported directly only by middleware.ts, whose edge bundle cannot carry
// the rest of campaignPartner.const. App code takes these from there, which re-exports them.

export const CAMPAIGN_PARTNER_PARAM = 'partner'

// A grouped partner's key is its slug path, `<group>/<partner>`, as in PartnerDetails.
// Every PartnerDetails key, by hand: the edge bundle cannot import partners.consts.
export const enum CampaignPartner {
  COX = 'cox',
  APPALACHIAN = 'appalachian',
  ACOM = 'acom',
  PEACHJAR = 'peachjar',
  ATXMOM = 'atxmom',
  ELEVKALENDEREN = 'elevkalenderen',
  CFA = 'cfa',
  CELLCOM = 'cellcom',
  AMAZON = 'amazon',
  STACKBYME = 'stackbyme',
  DNB_UNG_PLUSS = 'dnb/ung-pluss',
  DNB_SAGA_PRIVATE_BANKING = 'dnb/saga-private-banking',
}

/** Allowlist: the value is visitor-supplied and picks the Stripe price the checkout is handed. */
export const FUNNEL_PARTNER_KEYS: string[] = [
  CampaignPartner.COX,
  CampaignPartner.APPALACHIAN,
  CampaignPartner.ACOM,
  CampaignPartner.PEACHJAR,
  CampaignPartner.ATXMOM,
  CampaignPartner.ELEVKALENDEREN,
  CampaignPartner.CFA,
  CampaignPartner.CELLCOM,
  CampaignPartner.AMAZON,
  CampaignPartner.STACKBYME,
  CampaignPartner.DNB_UNG_PLUSS,
  CampaignPartner.DNB_SAGA_PRIVATE_BANKING,
]
